"use client";

import clsx from "clsx";
import type { ComponentProps } from "react";

import { useHeaderStore } from "@widgets/header/model/header-store";
import { Page } from "@widgets/Page";

import type { TrailPageType } from "../model";
import { Content } from "./content";
import { Gallery } from "./gallery";

import s from "./single-trail-page.module.scss";

export type SingleTrailPageProps = ComponentProps<"div"> & {
  className?: string;
  trail: TrailPageType;
};

export const SingleTrailPage = (props: SingleTrailPageProps) => {
  const { className, trail } = props;

  const { isHidden } = useHeaderStore();

  return (
    <Page
      className={clsx(s.root, className, {
        [s.headerHidden]: isHidden,
      })}
    >
      <div className={s.contentWrap}>
        <Content trail={trail} className={s.content} />
      </div>
      {trail.gallery && trail.gallery.length > 0 && (
        <Gallery gallery={trail.gallery} />
      )}
    </Page>
  );
};

SingleTrailPage.displayName = "SingleTrailPage";
